import Api from '@/api/Api'

class Mode extends Api {
  protected resource = 'mode'
}

export default new Mode()
